import React from 'react';
import {ApolloProvider} from '@apollo/react-hooks';
import ApolloClient from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLink} from "apollo-link-http";
import {setContext} from 'apollo-link-context'
import {useCurrentUser} from './CurrentUserProvider';

const httpLink = new HttpLink({
    uri: `${window.location.origin}/graphql`
});

const ApolloContextProvider = (/** @type {{ children: React.ReactNode; }} */ props) => {
    const currentUser = useCurrentUser();

    const authLink = setContext(async (_, {headers}) => {
        let accessToken = '';
        // try {
        //   if (!currentUser || !currentUser.accessToken) {
        //     throw Error("signed out");
        //   }
        //   const accessToken = currentUser.accessToken

        //   return {
        //     headers: {
        //       ...headers,
        //       authorization: accessToken ? `Bearer ${accessToken}` : ''
        //     }
        //   }
        // } catch (e) {
        //   console.error("couldn't get access token " + e);
        //   return {
        //     headers: {
        //       ...headers,
        //     }
        //   }
        // }

        try {
            const oktaTokenStorage = sessionStorage.getItem('okta-token-storage');
            if (oktaTokenStorage) {
                const tokenObj = JSON.parse(oktaTokenStorage);
                accessToken = tokenObj && tokenObj.accessToken && tokenObj.accessToken.accessToken;
            }
        } catch (e) {
            console.error('Could not parse okta-token-storage', e);
        }
        return {
            headers: {
                ...headers,
                authorization: accessToken ? `Bearer ${accessToken}` : ''
            }
        };
    });

    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache({
            dataIdFromObject: o => (o.id ? `${o.__typename}:${o.id}` : null),
        })
    });

    return (
        <ApolloProvider client={client}>
            {props.children}
        </ApolloProvider>
    );
};

export default ApolloContextProvider;